import { isDefined } from '@hsp/utilities';

import { ICancellationController, ICancellationRequestHandler } from 'types/services/http';

export function buildCancellationHandlers(keys: string[], handlers: Record<string, ICancellationRequestHandler>) {
  // an object that will contain a cancellation handler
  // associated to each API property name in the apiObject API object
  handlers = {};

  // each property in the apiObject API layer object
  // is associated with a function that defines an API call

  // this loop iterates over each API property name
  keys.forEach((key) => {
    const cancellation: ICancellationController = {};

    // associating the request cancellation handler with the API property name
    handlers[key] = {
      onCancellation: () => {
        // if the controller already exists, canceling the request
        if (isDefined(cancellation.controller)) {
          // canceling the request and returning this custom message
          cancellation.controller.abort();
        }

        // generating a new controller with the AbortController factory
        cancellation.controller = new AbortController();

        return cancellation.controller;
      },
    };
  });

  return handlers;
}
